import React from 'react'
import reactStamp from 'react-stamp'
import req from 'reqwest';
import Header from '../components/Header'
import Links from '../router/links'
import Register from '../components/Register'
import CircularProgress from 'material-ui/CircularProgress';

export default reactStamp(React).compose({

    init(){
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleRegisterNewUserResponse = this.handleRegisterNewUserResponse.bind(this);
        this.handleRegisterNewUserError = this.handleRegisterNewUserError.bind(this);
        this.handleRegisterNewUser = this.handleRegisterNewUser.bind(this);
    },

    state: {
        emailError: "",
        loading: false
    },

    render() {
        const circularStyles = {
            loader: {
                textAlign: "center",
                marginTop: "30%",
                width: "100%"
            }
        };
        if (this.isUserLogged()) {
            Links.toPortal();
            return null;
        } else {
            return (
                <div>
                    <Header operations="login"/>
                    {
                        (this.state.loading) ? <CircularProgress style={circularStyles.loader} size={2}/> :
                            <Register handleSubmit={this.handleSubmit} emailError={this.state.emailError}/>
                    }
                </div>
            );
        }
    },

    handleSubmit(email,
                 password,
                 firstname,
                 familyName,
                 gender,
                 addressLine,
                 city,
                 state,
                 district,
                 postalCode,
                 country,
                 phoneNumber,
                 birthDate){

        let _state = {};

        _state.login = email;
        _state.password = password;
        _state.name = {
            "family": familyName,
            "given": firstname,
            "prefix": "",
            "suffix": ""
        };
        _state.gender = gender;
        _state.phone = phoneNumber;
        _state.careProvider = "1";
        _state.address = {
            "line": addressLine,
            "city": city,
            "district": district,
            "state": state,
            "postalCode": postalCode,
            "country": country
        };
        _state.birthDate = birthDate;
        this.setState(_state, ()=> {
            this.handleRegisterNewUser(this.state);
        });


    },

    handleRegisterNewUser(userData){
        this.setState({loading: true});
        console.log(userData);
        req({
            url: "https://portal-experience-api.cloudhub.io/api/signup",
            // url: "link",
            method: 'POST',
            contentType: "application/json",
            crossOrigin: true,
            data: JSON.stringify(userData)
        })
            .then((resp) => this.handleRegisterNewUserResponse(resp))
            .fail((err, msg) => this.handleRegisterNewUserError(err, msg))
            .always((resp) => {
            });
    },

    handleRegisterNewUserResponse(resp){
        this.setState({
            loading: false,
            emailError: ""
        });
        console.log("Registration was successful --" + this.state.login);
        sessionStorage.setItem("email", this.state.login);

        Links.toLogin();
    },

    handleRegisterNewUserError(err, msg){
        this.setState({loading: false});
        console.log("Registration failed");
        if (err.status == "409") {
            this.setState({emailError: "Email already used"});
        }
    },

    isUserLogged() {
        return (sessionStorage.getItem("id") != "" && sessionStorage.getItem("id") != undefined)
    }

});


/** WEBPACK FOOTER **
 ** ./src/app/containers/Register.js
 **/